import Typography from '@mui/material/Typography'
import { IClosure } from '@store/features/closure/closure.types'
import { Box } from '@mui/material'

import ClosuresItem from '../ClosureItem'
import { StyledCourseName } from './styled'

interface Props {
  closures: IClosure[]
  courseName: string
  next: (closureId?: string) => void
  reload: () => void
}

const ClosuresList = ({ closures, courseName, next, reload }: Props) => {
  return (
    <Box>
      <Typography component='h4' variant='h4' align='center'>
        Course Closures
      </Typography>
      {courseName && <StyledCourseName>{courseName}</StyledCourseName>}
      {closures?.length ? (
        closures.map((closure) => (
          <ClosuresItem
            key={closure.id}
            reload={reload}
            closure={closure}
            next={next}
          />))
      ) : (
        <Box sx={{ padding: '30px 200px' }} />
      )}
    </Box>
  )
}

export default ClosuresList
